import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  const refresh = useCallback(async () => {
    const t = localStorage.getItem("svc_admin_token");
    if (!t) { setUser(null); setReady(true); return; }
    try {
      const { data } = await api.get("/admin/me");
      setUser(data);
    } catch {
      localStorage.removeItem("svc_admin_token");
      setUser(null);
    } finally { setReady(true); }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/admin/login", { email, password });
    localStorage.setItem("svc_admin_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("svc_admin_token");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, ready, login, logout, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
